module.exports = __webpack_public_path__ + "static/media/Trade_Trade_city.a0a5ba0c.png";